export default __webpack_public_path__ + "static/media/Link.ef7f003b.png";